export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["FetchStart"] = "FETCH_START";
    ActionTypes["FetchFailure"] = "FETCH_FAILURE";
    ActionTypes["FetchSuccess"] = "FETCH_SUCCESS";
    ActionTypes["ResetState"] = "RESET_STATE";
})(ActionTypes || (ActionTypes = {}));
